import { z } from 'zod'

export const requestReapproSimulationAllStoresByEmailSchema = z.object({
  emails: z.array(z.email()),
  sendToPilotage: z.boolean(),
  referenceDate: z.iso.datetime({ offset: true }).optional(),
})

export type RequestReapproSimulationAllStoresByEmailInput = z.infer<
  typeof requestReapproSimulationAllStoresByEmailSchema
>
